'use client';
import { usePathname } from 'next/navigation';
import { SELECTED_PLACE_ZOOM } from '@th/shared/src/constants/map';
import { useMap } from '../contexts/MapContext';
import { Place } from '@th/shared/src/types/Place';
import turfBbox from '@turf/bbox';

export default function useNavToPlace() {
  const pathname = usePathname();
  const isOnMapPage = pathname === '/m';
  const { focusCameraAndSetPinTo, focusCameraToBounds, updateAreaOverlay } =
    useMap();

  function navToPlace(place: Place): void {
    if (isOnMapPage) {
      if (place.geoJsonFeature) {
        updateAreaOverlay(place);
        const bbox = turfBbox(place.geoJsonFeature);
        focusCameraToBounds([
          [bbox[0], bbox[1]],
          [bbox[2], bbox[3]],
        ]);
      } else {
        focusCameraAndSetPinTo({
          longitude: place.center[0],
          latitude: place.center[1],
        });
      }
    } else {
      window.open(
        `/m?lat=${place.center[1]}&lng=${place.center[0]}&zoom=${SELECTED_PLACE_ZOOM}`,
        '_blank',
        'noopener,noreferrer',
      );
    }
  }

  return navToPlace;
}
